import { RootState } from '@/stores/store';

export const getType = (state: RootState) => state.global.appType;

export const getTeamType = (state: RootState) => state.global.teamType;

export const getAppID = (state: RootState) => state.global.appId;

export const getAppInfo = (state: RootState) => state.global.appInfo;
